import React, { useEffect, useRef, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import '../../assets/css/dashboard.scss'
import totalCustomer from '../../assets/images/Dashboard/total-customer-img.svg'
import activeInactive from '../../assets/images/Dashboard/total-active-inactive-img.svg'
import customerUnderValidity from '../../assets/images/Dashboard/total-customer-under-validity.svg'
import customerLicenseExperation from '../../assets/images/Dashboard/customer-licence-expiration.svg'
import Main from '../Main'
import Download from '../MainSection/Download/Download'
import BarChart from '../Graphs/BarChart'
import RelationshipTypeChart from '../Graphs/RelationshipTypeChart'
import FunnelChart from '../Graphs/FunnelChart'
import LicenceSpliteUpChart from '../Graphs/LicenceSpliteUpChart'
import AssignedModules from '../Graphs/AssignedModules'
import CustomerStatusChart from '../Graphs/CustomerStatusChart'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { loadLicenceDashboardCardData } from '../../redux/action'
import Skeleton from 'react-loading-skeleton'
import loader from '../../../src/assets/images/Dashboard/loader.gif'

function LicenceDashboard() {

    let dispatch = useDispatch();

    const { getLicenceDashboardCardData } = useSelector((state) => state.data);
    const { customViews = [] } = useSelector((state) => state.data);

    const [loading, setLoading] = useState(true);
    const [selectedDashboardID, setSelectedDashboardID] = useState(null);

    useEffect(() => {
        dispatch(loadLicenceDashboardCardData(null, setLoading));
    }, []);

    // Default state for the number of days (between 0 and 30)
    const [daysRemaining, setDaysRemaining] = useState(30);

    // Handler for changing the range slider value
    const handleSliderChange = (event) => {
        const newDays = parseInt(event.target.value, 10); // Update daysRemaining with slider value
        setDaysRemaining(newDays);

        // Pass the updated LicenseExpiryDays value to the API (only for the License Expiration card)
        dispatch(loadLicenceDashboardCardData(newDays, setLoading));  // Passing the new daysRemaining value to the API call
    };

    const labels = ['Active', 'Inactive', 'New'];
    const colors = [
        'rgba(58, 201, 119, 1)',  // Active
        'rgba(255, 94, 94, 1)', // Inactive
        'rgba(255, 159, 0, 1)', // New
    ];
    const data = [350, 50, 100];

    const funnelColors = ['rgba(0, 133, 163, 1)', 'rgba(3, 170, 207, 1)', 'rgba(6, 201, 244, 1)'];
    const funnelLabels = ['LC Available', 'LC Used', 'LC Provider'];
    const funnelData = [
        { value: 200 },
        { value: 150 },
        { value: 100 },
    ];
    const navigate = useNavigate();
    const handleBack = () => {
        const moduleId = 3;
        navigate('/usermanagement', { state: { moduleId } });
    };

    const handleDashboardLibraryClick = () => {
        navigate('/dashboard-library')
    }

    const handleNavigation = () => {
        navigate('/usermanagement')
    }

    const LicenceDetailsBarChartRef = useRef(null);
    const userLicenceSpliteUpRef = useRef(null);
    const NoofLicenceFunnelRef = useRef(null);
    const licenceStatusChartRef = useRef(null);

    const handleDownloadExcel = () => {
        LicenceDetailsBarChartRef.current.handleDownloadExcel();
        userLicenceSpliteUpRef.current.handleDownloadExcel();
        NoofLicenceFunnelRef.current.handleDownloadExcel();
        licenceStatusChartRef.current.handleDownloadExcel();
    }

    const handleDownloadPDF = () => {
        // Call BarChart's handleDownloadPDF method here
        LicenceDetailsBarChartRef.current.handleDownloadPDF();
        userLicenceSpliteUpRef.current.handleDownloadPDF();
        NoofLicenceFunnelRef.current.handleDownloadPDF();
        licenceStatusChartRef.current.handleDownloadPDF();
    };
    const handleDownloadWord = () => {
        // Call BarChart's handleDownloadPDF method here
        LicenceDetailsBarChartRef.current.handleDownloadWord();
        userLicenceSpliteUpRef.current.handleDownloadWord();
        NoofLicenceFunnelRef.current.handleDownloadWord();
        licenceStatusChartRef.current.handleDownloadWord();
    };

    // const handlePrint = () => {
    //     // Call BarChart's handleDownloadPDF method here
    //     // Ensure refs are correctly set before calling print
    //     if (LicenceDetailsBarChartRef.current && userLicenceSpliteUpRef.current && NoofLicenceFunnelRef.current && licenceStatusChartRef.current) {
    //         LicenceDetailsBarChartRef.current.handlePrint();
    //         userLicenceSpliteUpRef.current.handlePrint();
    //         NoofLicenceFunnelRef.current.handlePrint();
    //         licenceStatusChartRef.current.handlePrint();
    //     } else {
    //         console.error('One or more refs are not initialized.');
    //     }
    // };

    const handlePrint = async () => {
        let printableContent = '<html><head><title>Print Charts</title></head><body>';

        const refs = [
            LicenceDetailsBarChartRef.current,
            userLicenceSpliteUpRef.current,
            NoofLicenceFunnelRef.current,
            licenceStatusChartRef.current
        ];

        for (const ref of refs) {
            if (ref && ref.handleDownloadImage) {
                try {
                    const imageSrc = await ref.handleDownloadImage(); // Get image URL
                    if (imageSrc) {
                        printableContent += `<img src="${imageSrc}" style="width:100%; margin-bottom: 20px;" />`;
                    }
                } catch (error) {
                    console.error(`Error getting image from chart:`, error);
                }
            } else {
                console.error('One or more refs are not initialized or missing handleDownloadImage.');
            }
        }

        printableContent += '</body></html>';

        const printWindow = window.open('', '_blank');
        if (printWindow) {
            printWindow.document.open();
            printWindow.document.write(printableContent);
            printWindow.document.close();
            setTimeout(() => {
                printWindow.print();
                printWindow.close();
            }, 500);
        } else {
            console.error("Popup blocked. Please allow popups for this site.");
        }
    };

    const handleDownloadImage = () => {
        // Call BarChart's handleDownloadPDF method here
        LicenceDetailsBarChartRef.current.handleDownloadImage();
        userLicenceSpliteUpRef.current.handleDownloadImage();
        NoofLicenceFunnelRef.current.handleDownloadImage();
        licenceStatusChartRef.current.handleDownloadImage();
    };

    const determineColumnSize = (visibleCols) => {
        if (visibleCols === 1) {
            return 12;  // One column takes the full width
        } else if (visibleCols === 2) {
            return 6;  // Two columns each take half the width
        } else if (visibleCols === 3) {
            return 4;  // Three columns each take a third of the width
        } else if (visibleCols >= 4) {
            return 3;  // Four or more columns each take a quarter of the width
        }
        return 4;  // Default fallback
    };

    return (
        <div className='dashboard-container'>
            <Main>
                {loading ? (
                    <div className="loading-container" style={{ position: 'absolute', top: '40%', left: '40%' }}>
                        <img src={loader} style={{ width: '180px' }} />
                    </div>
                ) : (
                    <>
                        <div className='components-download-container'>
                            <Download moduleName={customViews?.[0]?.DashboardName || "User Dashboard"}
                                showBackButton={true}
                                showDashboardLibraryButton={true}
                                showSaveCustomViewButton={true}
                                showAnalyticsButton={false}
                                showDownloadDropdown={true}
                                showCustomViewDropdown={true}
                                onClick={handleDashboardLibraryClick}
                                onBackClick={handleBack}
                                onExcelDownloadClick={handleDownloadExcel}
                                onPdfDownloadClick={handleDownloadPDF}
                                onWordDownloadClick={handleDownloadWord}
                                onPrintClick={handlePrint}
                                onImageClick={handleDownloadImage}
                                customViews={customViews}
                                onCustomDashboardSelect={setSelectedDashboardID}
                            />
                        </div>
                        {/* <Row className='dashboard-cards-container'>
                    <Col md={3} className='p-0 pe-3 dashboard-cards-cols'>
                        <div className='dashboard-cards'
                        // onClick={handleNavigation}
                        >
                            <div className='dashboard-cards-counts'>
                                <p>Total Licence</p>
                                <b>{loading ? <Skeleton width={100} /> : getLicenceDashboardCardData?.TotalUsers}</b>
                            </div>
                            <div className='dashboard-cards-image'>
                                <img src={totalCustomer} alt="" />
                            </div>
                        </div>
                    </Col>
                    <Col md={3} className='p-0 pe-3 dashboard-cards-cols'>
                        <div className='dashboard-cards'
                        //  onClick={handleNavigation}
                        >
                            <div className='dashboard-cards-counts'>
                                <p>Active / InActive</p>
                                <b>{loading ? <Skeleton width={100} /> : `${getLicenceDashboardCardData?.ActiveUsers}/${getLicenceDashboardCardData?.InActiveUsers}`}</b>
                            </div>
                            <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 94, 94, 0.2)" }}>
                                <img src={activeInactive} alt="" />
                            </div>
                        </div>
                    </Col>
                    <Col md={3} className='p-0 pe-3 dashboard-cards-cols'>
                        <div className='dashboard-cards'
                        // onClick={handleNavigation}
                        >
                            <div className='dashboard-cards-counts'>
                                <p>Licence Under Validity</p>
                                <b>{loading ? <Skeleton width={100} /> : getLicenceDashboardCardData?.ValidUsers}</b>
                            </div>
                            <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 159, 0, 0.2)" }}>
                                <img src={customerUnderValidity} alt="" />
                            </div>
                        </div>
                    </Col>
                    <Col md={3} className='p-0 dashboard-cards-cols'>
                        <div className='dashboard-cards'>
                            <div className='dashboard-cards-counts'>
                                <p>License Expiration</p>
                                <b>{loading ? <Skeleton width={100} /> : getLicenceDashboardCardData?.LicenseExpiringUsers}</b>
                                <p className="dashboard-expiring-text">Expiring in {daysRemaining} days</p>
                                <div className="dashboard-progress-bar">
                                    <input
                                        type="range"
                                        min="0"
                                        max="30"
                                        value={daysRemaining}
                                        onChange={handleSliderChange}
                                    // style={{ width: "100%", accentColor: "rgb(52, 58, 64)", height: "0.2rem" }} // Make the slider full width
                                    />
                                </div>
                            </div>
                            <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(52, 58, 64, 0.2)" }}>
                                <img src={customerLicenseExperation} alt="" />
                            </div>
                        </div>
                    </Col>
                </Row> */}

                        <Row className='dashboard-cards-container'>
                            { // Case 1: customViews is empty → show all cards
                                // loading ? (
                                //     // Show loading indicator, e.g.
                                //     <div><img src={loader} style={{ height: '150px', width: '150px' }} /></div>
                                // ) :
                                (!customViews || customViews.length === 0 || (!selectedDashboardID && customViews[0]?.IsDefault === false)) ? (
                                    <>
                                        {/* Total Customer */}
                                        <Col md={3} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                            <div className='dashboard-cards'
                                            // onClick={handleNavigation}
                                            >
                                                <div className='dashboard-cards-counts'>
                                                    <p>Total Licence</p>
                                                    <b>{loading ? <Skeleton width={100} /> : getLicenceDashboardCardData?.TotalUsers}</b>
                                                </div>
                                                <div className='dashboard-cards-image'>
                                                    <img src={totalCustomer} alt="" />
                                                </div>
                                            </div>
                                        </Col>

                                        {/* Active / Inactive */}
                                        <Col md={3} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                            <div className='dashboard-cards'
                                            //  onClick={handleNavigation}
                                            >
                                                <div className='dashboard-cards-counts'>
                                                    <p>Active / InActive</p>
                                                    <b>{loading ? <Skeleton width={100} /> : `${getLicenceDashboardCardData?.ActiveUsers}/${getLicenceDashboardCardData?.InActiveUsers}`}</b>
                                                </div>
                                                <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 94, 94, 0.2)" }}>
                                                    <img src={activeInactive} alt="" />
                                                </div>
                                            </div>
                                        </Col>

                                        {/* Customer Under Validity */}
                                        <Col md={3} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                            <div className='dashboard-cards'
                                            // onClick={handleNavigation}
                                            >
                                                <div className='dashboard-cards-counts'>
                                                    <p>Licence Under Validity</p>
                                                    <b>{loading ? <Skeleton width={100} /> : getLicenceDashboardCardData?.ValidUsers}</b>
                                                </div>
                                                <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 159, 0, 0.2)" }}>
                                                    <img src={customerUnderValidity} alt="" />
                                                </div>
                                            </div>
                                        </Col>

                                        {/* Customer License Expiration */}
                                        <Col md={3} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                            <div className='dashboard-cards'>
                                                <div className='dashboard-cards-counts'>
                                                    <p>License Expiration</p>
                                                    <b>{loading ? <Skeleton width={100} /> : getLicenceDashboardCardData?.LicenseExpiringUsers}</b>
                                                    <p className="dashboard-expiring-text">Expiring in {daysRemaining} days</p>
                                                    <div className="dashboard-progress-bar">
                                                        <input
                                                            type="range"
                                                            min="0"
                                                            max="30"
                                                            value={daysRemaining}
                                                            onChange={handleSliderChange}
                                                        // style={{ width: "100%", accentColor: "rgb(52, 58, 64)", height: "0.2rem" }} // Make the slider full width
                                                        />
                                                    </div>
                                                </div>
                                                <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(52, 58, 64, 0.2)" }}>
                                                    <img src={customerLicenseExperation} alt="" />
                                                </div>
                                            </div>
                                        </Col>
                                    </>
                                ) : (
                                    // Case 2: customViews is not empty → show based on GraphLibraryID
                                    customViews?.map((view, viewIndex) => {
                                        let visibleCols = 0;

                                        // Count how many graphs are visible based on conditions
                                        view.Graphs.forEach((graph) => {
                                            if (graph.GraphLibraryID === 11) visibleCols += 1;
                                            if (graph.GraphLibraryID === 12) visibleCols += 1;
                                            if (graph.GraphLibraryID === 13) visibleCols += 1;
                                            if (graph.GraphLibraryID === 14) visibleCols += 1;
                                        });

                                        const columnSize = determineColumnSize(visibleCols); // Calculate `md` value based on visible columns

                                        return view.Graphs?.map((graph, index) => {
                                            if (graph.GraphLibraryID === 11) {
                                                return (
                                                    <Col md={columnSize} key={index} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                                        <div className='dashboard-cards'
                                                        // onClick={handleNavigation}
                                                        >
                                                            <div className='dashboard-cards-counts'>
                                                                <p>Total Licence</p>
                                                                <b>{loading ? <Skeleton width={100} /> : getLicenceDashboardCardData?.TotalUsers}</b>
                                                            </div>
                                                            <div className='dashboard-cards-image'>
                                                                <img src={totalCustomer} alt="" />
                                                            </div>
                                                        </div>
                                                    </Col>
                                                );
                                            }

                                            if (graph.GraphLibraryID === 12) {
                                                return (
                                                    <Col md={columnSize} key={index} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                                        <div className='dashboard-cards'
                                                        //  onClick={handleNavigation}
                                                        >
                                                            <div className='dashboard-cards-counts'>
                                                                <p>Active / InActive</p>
                                                                <b>{loading ? <Skeleton width={100} /> : `${getLicenceDashboardCardData?.ActiveUsers}/${getLicenceDashboardCardData?.InActiveUsers}`}</b>
                                                            </div>
                                                            <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 94, 94, 0.2)" }}>
                                                                <img src={activeInactive} alt="" />
                                                            </div>
                                                        </div>
                                                    </Col>
                                                );
                                            }

                                            if (graph.GraphLibraryID === 13) {
                                                return (
                                                    <Col md={columnSize} key={index} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                                        <div className='dashboard-cards'
                                                        // onClick={handleNavigation}
                                                        >
                                                            <div className='dashboard-cards-counts'>
                                                                <p>Licence Under Validity</p>
                                                                <b>{loading ? <Skeleton width={100} /> : getLicenceDashboardCardData?.ValidUsers}</b>
                                                            </div>
                                                            <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 159, 0, 0.2)" }}>
                                                                <img src={customerUnderValidity} alt="" />
                                                            </div>
                                                        </div>
                                                    </Col>
                                                );
                                            }

                                            if (graph.GraphLibraryID === 14) {
                                                return (
                                                    <Col md={columnSize} key={index} className="p-0 pe-3 ps-1 dashboard-cards-cols">
                                                        <div className='dashboard-cards'>
                                                            <div className='dashboard-cards-counts'>
                                                                <p>License Expiration</p>
                                                                <b>{loading ? <Skeleton width={100} /> : getLicenceDashboardCardData?.LicenseExpiringUsers}</b>
                                                                <p className="dashboard-expiring-text">Expiring in {daysRemaining} days</p>
                                                                <div className="dashboard-progress-bar">
                                                                    <input
                                                                        type="range"
                                                                        min="0"
                                                                        max="30"
                                                                        value={daysRemaining}
                                                                        onChange={handleSliderChange}
                                                                    // style={{ width: "100%", accentColor: "rgb(52, 58, 64)", height: "0.2rem" }} // Make the slider full width
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(52, 58, 64, 0.2)" }}>
                                                                <img src={customerLicenseExperation} alt="" />
                                                            </div>
                                                        </div>
                                                    </Col>
                                                );
                                            }

                                            return null; // If no matching GraphLibraryID, return nothing
                                        });
                                    })
                                )}
                        </Row>
                        {/* <Row className='dashboard-charts'>
                    <Col md={6} className='dashboard-charts-div p-0 '>
                        <div className='charts-container'>
                            <BarChart
                                moduleName="Licence Details"
                                showCompany={true}
                                showYear={true}
                                ref={LicenceDetailsBarChartRef}
                            />
                        </div>
                    </Col>
                    <Col md={3} className='dashboard-charts-div p-0 '>
                        <div className='charts-container'>
                            <CustomerStatusChart
                                moduleName="Licence Status"
                                labels={labels}
                                colors={colors}
                                data={data}
                                showYear={true}
                                showCompany={true}
                                ref={licenceStatusChartRef}
                            />
                        </div>
                    </Col>
                    <Col md={3} className='dashboard-charts-div p-0 pe-4'>
                        <div style={{ height: "100%" }}>
                            <FunnelChart
                                moduleName="No of Licence" colors={funnelColors} labels={funnelLabels} data={funnelData}
                                ref={NoofLicenceFunnelRef}
                            />
                        </div>
                    </Col>
                </Row> */}

                        <Row className='dashboard-charts'>
                            {/* Case 1: customViews is empty → show all cards */}
                            {(!customViews || customViews.length === 0 || (!selectedDashboardID && customViews[0]?.IsDefault === false)) ? (
                                (() => {
                                    const charts = [
                                        {
                                            id: 15, component: (
                                                <div className='charts-container  pe-2 ps-1'>
                                                    <BarChart
                                                        moduleName="Licence Details"
                                                        showCompany={true}
                                                        showYear={true}
                                                        ref={LicenceDetailsBarChartRef}
                                                    />
                                                </div>
                                            )
                                        },
                                        {
                                            id: 16, component: (
                                                <div className='charts-container  pe-2 ps-1'>
                                                    <CustomerStatusChart
                                                        moduleName="Licence Status"
                                                        labels={labels}
                                                        colors={colors}
                                                        data={data}
                                                        showYear={true}
                                                        showCompany={true}
                                                        ref={licenceStatusChartRef}
                                                    />
                                                </div>
                                            )
                                        },
                                        {
                                            id: 17, component: (
                                                <div className='charts-container  pe-2 ps-1'>
                                                    <FunnelChart
                                                        moduleName="No of Licence" colors={funnelColors} labels={funnelLabels} data={funnelData}
                                                        ref={NoofLicenceFunnelRef}
                                                    />
                                                </div>
                                            )
                                        }
                                    ];

                                    return charts.map(({ id, component }, index) => {
                                        let colSize = 12;
                                        if (charts.length === 2) colSize = 6;
                                        if (charts.length === 3) colSize = id === 15 ? 6 : 3;

                                        return (
                                            <Col
                                                key={id}
                                                xs={12}
                                                sm={12}
                                                md={colSize}
                                                lg={colSize}
                                                className={`dashboard-charts-div p-0 ${id === 17 ? 'pe-1' : ''}`}
                                            >
                                                <div className='charts-container' style={{ height: '100%' }}>
                                                    {component}
                                                </div>
                                            </Col>
                                        );
                                    });
                                })()
                            ) : (
                                // Case 2: customViews is not empty → show based on GraphLibraryID
                                customViews.map((view, viewIndex) => {
                                    const visibleGraphs = view.Graphs?.filter(graph =>
                                        [15, 16, 17].includes(graph.GraphLibraryID)
                                    ) || [];

                                    return visibleGraphs.map((graph, index) => {
                                        const id = graph.GraphLibraryID;

                                        let colSize = 12;
                                        if (visibleGraphs.length === 2) colSize = 6;
                                        if (visibleGraphs.length === 3) colSize = id === 15 ? 6 : 3;

                                        let chartComponent = null;

                                        if (id === 15) {
                                            chartComponent = (
                                                <div className='charts-container  pe-2 ps-1'>
                                                    <BarChart
                                                        moduleName="Licence Details"
                                                        showCompany={true}
                                                        showYear={true}
                                                        ref={LicenceDetailsBarChartRef}
                                                    />
                                                </div>
                                            );
                                        }

                                        if (id === 16) {
                                            chartComponent = (
                                                <div className='charts-container  pe-2 ps-1'>
                                                    <CustomerStatusChart
                                                        moduleName="Licence Status"
                                                        labels={labels}
                                                        colors={colors}
                                                        data={data}
                                                        showYear={true}
                                                        showCompany={true}
                                                        ref={licenceStatusChartRef}
                                                    />
                                                </div>
                                            );
                                        }

                                        if (id === 17) {
                                            chartComponent = (
                                                <div className='charts-container  pe-2 ps-1'>
                                                    <FunnelChart
                                                        moduleName="No of Licence" colors={funnelColors} labels={funnelLabels} data={funnelData}
                                                        ref={NoofLicenceFunnelRef}
                                                    />
                                                </div>
                                            );
                                        }

                                        return (
                                            <Col
                                                key={index}
                                                xs={12}
                                                sm={12}
                                                md={colSize}
                                                lg={colSize}
                                                className={`dashboard-charts-div p-0 ${id === 7 ? 'pe-1' : ''}`}
                                            >
                                                <div className='charts-container' style={{ height: '100%' }}>
                                                    {chartComponent}
                                                </div>
                                            </Col>
                                        );
                                    });
                                })
                            )}
                        </Row>
                        {/* <Row className='dashboard-charts pt-4 pb-4'>
                    <Col md={9} className='dashboard-charts-div p-0'>
                        <div className='charts-container'>
                            <LicenceSpliteUpChart
                                ref={userLicenceSpliteUpRef}
                            />
                        </div>
                    </Col>

                    <Col md={3} className='dashboard-charts-div p-0 pe-4'>
                        <div style={{ height: "100%" }}>
                            <AssignedModules />
                        </div>
                    </Col>
                </Row> */}

                        <Row className='dashboard-charts pt-4 pb-4'>
                            {(!customViews || customViews.length === 0 || (!selectedDashboardID && customViews[0]?.IsDefault === false)) ? (
                                (() => {
                                    const charts = [
                                        {
                                            id: 18,
                                            component: (
                                                <div className='charts-container pe-2 ps-1 '>
                                                    <LicenceSpliteUpChart
                                                        ref={userLicenceSpliteUpRef}
                                                    />
                                                </div>
                                            )
                                        },
                                        {
                                            id: 19,
                                            component: (
                                                <div className='charts-container pe-2 ps-1 '>
                                                    <AssignedModules />
                                                </div>
                                            )
                                        },
                                    ];

                                    const count = charts.length;

                                    return charts.map(({ id, component }) => {
                                        let colSize = 12;
                                        // if (count === 2) colSize = 6;
                                        if (count === 2) colSize = id === 18 ? 9 : 3;

                                        return (
                                            <Col
                                                key={id}
                                                xs={12}
                                                sm={12}
                                                md={colSize}
                                                lg={colSize}
                                                className='dashboard-charts-div p-0'
                                            >
                                                <div className='charts-container' style={{ height: '100%' }}>
                                                    {component}
                                                </div>
                                            </Col>
                                        );
                                    });
                                })()
                            ) : (
                                customViews.map((view, viewIndex) => {
                                    const visibleGraphs = view.Graphs?.filter(graph =>
                                        [18, 19].includes(graph.GraphLibraryID)
                                    ) || [];

                                    return visibleGraphs.map((graph, index) => {
                                        const id = graph.GraphLibraryID;

                                        let colSize = 12;
                                        // if (visibleGraphs.length === 2) colSize = 6;
                                        if (visibleGraphs.length === 2) colSize = id === 18 ? 9 : 3;

                                        let chartComponent = null;

                                        if (id === 18) {
                                            chartComponent = (
                                                <div className='charts-container pe-2 ps-1'>
                                                    <LicenceSpliteUpChart
                                                        ref={userLicenceSpliteUpRef}
                                                    />
                                                </div>
                                            );
                                        }

                                        if (id === 19) {
                                            chartComponent = (
                                                <div className='charts-container pe-2 ps-1'>
                                                    <AssignedModules />
                                                </div>
                                            );
                                        }

                                        return (
                                            <Col
                                                key={index}
                                                xs={12}
                                                sm={12}
                                                md={colSize}
                                                lg={colSize}
                                                className='dashboard-charts-div p-0'
                                            >
                                                <div className='charts-container' style={{ height: '100%' }}>
                                                    {chartComponent}
                                                </div>
                                            </Col>
                                        );
                                    });
                                })
                            )}
                        </Row>
                    </>
                )}
            </Main>
        </div >
    )
}

export default LicenceDashboard

